/* 모바일 드로어 — 항목이 하나씩 순서대로 올라온다 (2026-09-09, 카페24 소스 대조)

   ⚠️⚠️ **카페24와 같은 방식이다 — `transition-delay` 가 아니라 항목별 상태 변경이다.**
      원본(`layout/basic/js/basic.js`)은 이렇게 한다:
        animate = setInterval(function () {
          cateItemElms[i].style.transform = 'translate3d(0,0,0)';
          cateItemElms[i].style.opacity = '1'; i++;
        }, 80);
      CSS 는 시작값(`opacity:0` · `translate3d(0,50px,0)`)과 전환(`all .3s ease-out`)만 갖는다.

   ⚠️⚠️ **왜 `transition-delay` 를 버렸나.** 지연 방식은 모든 항목의 상태가 **같은 프레임에
      한꺼번에** 바뀐다. 그때 브라우저가 스타일 변경을 합치거나(요소가 그 순간 보이기 시작하면
      특히) 지연을 무시하면 **여러 개가 동시에 뜬다** — 제보가 그 증상이었고, 그 전에는
      하드코딩된 `nth-*` 목록이 두 벌로 갈려 공백까지 있었다.
      상태 변경 자체를 시간에 흩뿌리면 합쳐질 여지가 없다.

   ⚠️ 순서는 `querySelectorAll` 의 **문서 순서**(1차 메뉴 → 얇은 링크)를 그대로 쓴다.
      두 목록을 따로 세지 않으므로 개수·로그인 여부가 바뀌어도 이어진다.
   ⚠️ **보이지 않는 항목은 건너뛴다** — 순번만 먹으면 화면에서 한 칸 빈 것처럼 보인다.
   ⚠️ 닫을 때는 **즉시** 되돌린다(카페24도 그렇다). 순서대로 사라지면 닫힘이 느리게 느껴진다.
   ⚠️ 다시 열기를 빠르게 반복해도 겹치지 않게 **이전 타이머를 먼저 끊는다**(카페24의
      `clearInterval(animate)` 와 같은 이유).
   ⚠️ `.nt-stagger-ready` 를 드로어에 붙인다 — CSS 폴백(스크립트 없으면 한꺼번에 표시)의 스위치다.
      **이 클래스를 떼지 말 것**: 떼면 폴백이 이겨서 순차 등장이 죽는다.
*/
(() => {
  var STEP = 80; /* ms — 카페24 `setInterval(…, 80)` */
  var MQ = '(max-width: 989px)';
  var SEL = '.nt-acc__item, .nt-drawer__utility-link';
  var ON = 'nt-stagger-in';

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function mobile() {
    return !window.matchMedia || window.matchMedia(MQ).matches;
  }

  function setup(container) {
    var drawer = container.querySelector('.nt-drawer');
    if (!drawer || container.dataset.ntStagger) return;
    container.dataset.ntStagger = '1';
    drawer.classList.add('nt-stagger-ready');

    var timer = null;

    function items() {
      return Array.prototype.filter.call(drawer.querySelectorAll(SEL), function (el) {
        return el.offsetParent !== null; /* 화면에 없는 항목은 순번을 먹지 않는다 */
      });
    }

    function reset() {
      if (timer) { clearInterval(timer); timer = null; }
      Array.prototype.forEach.call(drawer.querySelectorAll(SEL), function (el) {
        el.classList.remove(ON);
      });
    }

    function run() {
      reset();
      var list = items();
      if (!list.length) return;
      if (!mobile() || reduced()) {
        /* 데스크톱·모션 최소화 — 순차 없이 즉시 */
        list.forEach(function (el) { el.classList.add(ON); });
        return;
      }
      var i = 0;
      timer = setInterval(function () {
        if (i >= list.length) { clearInterval(timer); timer = null; return; }
        list[i].classList.add(ON);
        i++;
      }, STEP);
      /* 첫 항목은 기다리지 않는다 — 여는 즉시 하나는 올라와야 반응이 있다고 느낀다. */
      list[0].classList.add(ON);
      i = 1;
    }

    new MutationObserver(function () {
      if (container.classList.contains('menu-opening')) run();
      else reset();
    }).observe(container, { attributes: true, attributeFilter: ['class'] });

    if (container.classList.contains('menu-opening')) run();
  }

  function init() {
    document.querySelectorAll('.menu-drawer-container').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* 섹션을 다시 그리면(테마 편집기) 컨테이너가 교체된다 — 그때 다시 붙인다. */
  document.addEventListener('shopify:section:load', init);
})();
